var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player"},[_c('youtube',{ref:"youtube",staticClass:"player__video",attrs:{"resize":true,"fitParent":true,"video-id":_vm.youtubeId,"player-vars":_vm.playerVars}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }